import { render, staticRenderFns } from "./createForm.vue?vue&type=template&id=682b41ae&scoped=true&"
import script from "./createForm.vue?vue&type=script&lang=js&"
export * from "./createForm.vue?vue&type=script&lang=js&"
import style0 from "./createForm.vue?vue&type=style&index=0&id=682b41ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682b41ae",
  null
  
)

export default component.exports